import { t } from "../../constants/translationHelper";
import { getDefaultCompanyList } from "../../services/CommonServices";

/**
 * Export table data to CSV with company info, title, and date range
 * @param {Array} data - Table data
 * @param {Array} columns - Column definitions
 * @param {String} title - File title
 * @param {String} fromDate - From date string
 * @param {String} toDate - To date string
 */
export const handleExportData = async (
    data = [],
    columns = [],
    title = "Report",
    fromDate = "",
    toDate = ""
) => {
    try {
        // ✅ Fetch default company
        const { defaultCompany } = await getDefaultCompanyList();

        const safeData = Array.isArray(data) ? data : [];
        const safeColumns = Array.isArray(columns)
            ? columns.filter(
                (col) =>
                    col.accessorKey?.toLowerCase() !== "action" &&
                    col.header?.toLowerCase() !== "action"
            )
            : [];

        if (safeColumns.length === 0) {
            alert("No columns available for export.");
            return;
        }
        if (safeData.length === 0) {
            alert("No data available to export.");
            return;
        }

        // ✅ Headers
        const headers = safeColumns.map(
            (col) => t(col.header || col.accessorKey || "Column")
        );

        // ✅ Data Rows
        const rows = safeData.map((row) =>
            safeColumns.map((col) => {
                const key = col.accessorKey;
                return key ? row[key] ?? "" : "";
            })
        );

        // ✅ CSV Content
        let csvContent = "";

        // -------------------------------
        // 1️⃣ Company Header
        // -------------------------------
        if (defaultCompany) {
            csvContent += `"${defaultCompany.name}"\n`;
            csvContent += `"${defaultCompany.address}, ${defaultCompany.city}, ${defaultCompany.state}, ${defaultCompany.country} - ${defaultCompany.pincode}"\n`;
            csvContent += `"Mobile: ${defaultCompany.mobile} | Email: ${defaultCompany.email} | Website: ${defaultCompany.website}"\n\n`;
        }

        // -------------------------------
        // 2️⃣ Title + Date Range
        // -------------------------------
        csvContent += `"${t(title)}"\n`;

        if (fromDate && toDate) {
            csvContent += `"From: ${fromDate} To: ${toDate}"\n\n`;
        } else if (fromDate) {
            csvContent += `"From: ${fromDate}"\n\n`;
        } else if (toDate) {
            csvContent += `"To: ${toDate}"\n\n`;
        } else {
            csvContent += `""\n\n`;
        }

        // -------------------------------
        // 3️⃣ Table Header
        // -------------------------------
        csvContent += headers.map((h) => `"${h}"`).join(",") + "\n";

        // -------------------------------
        // 4️⃣ Table Rows
        // -------------------------------
        rows.forEach((row) => {
            csvContent +=
                row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(",") +
                "\n";
        });

        // -------------------------------
        // 5️⃣ Download CSV File
        // -------------------------------
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${title.replace(/\s+/g, "_")}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } catch (error) {
        console.error("CSV export failed:", error);
        alert("Error while exporting data. Please try again.");
    }
};
